<template>
    <div>
        <!-- <navbar-sas></navbar-sas> -->
        <div class=" tarjetaOperacion card m-5 p-4 mb-5">

            <div>
              <div class="text-center mt-3">
                  <h5>Selecciona el proceso de Pago y genera el Número de autorización.</h5>
              </div>
              <div class="row mt-4">
                  <div class="col-3"></div>
                  <div class="col-2">
                      <label class="form-label">Número de importacion</label>
                      <input type="text" class="form-control" v-model="numImportacion">
                  </div>
                  <div class="col-2">
                      <label class="form-label">Fecha inicial</label>
                      <input type="date" class="form-control" v-model="FechaI" placeholder="Número de importacion">
                  </div>
                  <div class="col-2">
                      <label class="form-label">Fecha Final</label>
                      <input type="date" class="form-control" v-model="FechaF" placeholder="Número de importacion">
                  </div>
                  <div class="col-3"></div>
              </div>
      
              <div class="row mt-4">
                  <div class="col-3"></div>
                  <div class="col-2">
                      <label class="form-label">Número de Factura</label>
                      <input type="text" class="form-control" v-model="numFactura">
                  </div>
                  <div class="col-2">
                      <label class="form-label">Seleccinar proveedor</label>
                      <CButton class="container" color="secondary" style="font-size: small;"
                      @click="openProveedor">Proveedor</CButton>
                  </div>
                  <div class="col-2 ml-4">
                      <div class="form-check">
                          <input @change="eventChecks($event, 'uno')" v-model="radio" value="Individual" class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1">
                          <label class="form-check-label" for="flexRadioDefault1">
                              Individual
                          </label>
                      </div>
                      <div class="form-check mt-2">
                          <input @change="eventChecks($event, 'dos')" v-model="radio" value="Masivo" class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2">
                          <label class="form-check-label" for="flexRadioDefault2">
                              Masivo
                          </label>
                      </div>
                  </div>
                  <div class="col-3"></div>
              </div>
              <div class="text-center">
                  <button @click="reporteCliente" type="button" class="btn btn-blue mt-3 col-3">
                      <i  style="color:#fffdfd;"  class="fas fa-check mr-2"></i>
                      Buscar
                  </button>
              </div>
      
            </div>
      
            
            <div class=" row mt-4 mb-4">
              <div class="col-1"></div>
              <div class="col-10 mb-5">
                  <div class="">
                      <div class="table-responsive">
      
                          <table class="table text-center">
                          <thead>
                              <tr>
                              <th scope="col"># Importacion</th>
                              <th scope="col">Fecha de Carga</th>
                              <th scope="col">Autorización</th>
                              <th scope="col">Tipo</th>
                              <th scope="col">Estatus</th>
                              <th scope="col">CheckList</th>
                              <th scope="col">Accion</th>
                              </tr>
                          </thead>
                          <tbody >
                              <tr v-for="(result, i) in listStatus" :key="i">
                                  <td>{{result.Importacion}}</td>
                                  <td>{{result.FechaCarga}}</td>
                                  <td>{{result.Autorizacion}}</td>
                                  <td>{{result.Tipo}}</td>
                                  <td>{{result.Estatus == '1' ? 'Inicia la importación' : 
                                        result.Estatus == '2' ? 'Aceptada' :
                                        result.Estatus == '3' ? 'Esperando cambios' :
                                        result.Estatus == '7' ? 'Pagada' :
                                        result.Estatus == '6' ? 'Autorizada' :
                                        result.Estatus == '5' ? 'Cancelada' : 'Indefinido'}}</td>
                                  <td>
                                      <button :disabled="result.Estatus == '2' || result.Estatus == '5' || result.Estatus == '7' || result.Estatus == '6'" @click="validarChecklist(result.Importacion, true)" type="button" class="btn btn-sm btn-primary-operacion border-radius-btn" v-if="result.Tipo == 'Individual'">
                                          <i style="color:#fffdfd;" class="fas fa-flask mr-2"></i>
                                          Validar
                                      </button>
                                  </td>
                                  <td>
                                      <button :disabled="result.Estatus == '1' || result.Estatus == '3' || result.Estatus == '5' || result.Estatus == '7' || result.Estatus == '6'" v-if="result.Tipo == 'Masiva'" @click="autorizar(result.Importacion)" type="button" class="mt-1 btn btn-sm btn-success border-radius-btn">
                                          <i style="color:#fffdfd;" class="fas fa-check-circle mr-2"></i>
                                          Autorizar
                                      </button>
                                      <!-- :disabled="result.DISABLED" -->
                                      <button :disabled="result.Estatus == '1' || result.Estatus == '3' || result.Estatus == '5' || result.Estatus == '7'  || result.Estatus == '6'" v-else @click="openModal(result.Importacion)" type="button" class="btn btn-sm btn-success border-radius-btn">
                                          <i style="color:#fffdfd;" class="fas fa-check-circle mr-2"></i>
                                          Autorizar 
                                      </button>
                                      <button :disabled="result.Estatus == '7' || result.Estatus == '5' || result.Estatus == '2'" @click="cancelarImp(result.Importacion, result.Autorizacion)" type="button" class="btn btn-sm btn-info border-radius-btn ml-1">
                                        <i style="color:#fffdfd;" class="fas fa-sync-alt mr-2"></i>
                                        Status
                                    </button>
                                      <button @click="info(result.Importacion)" type="button" class="btn btn-sm btn-light border-radius-btn ml-1 mt-1"><i class="fas fa-eye mr-2"></i>info</button>
                                  </td>
                              </tr>
                          </tbody>
                          </table>
                      </div>
                  </div>
              </div>
              <div class="col-1"></div>
                  
              </div>
        </div>


        <!-- Modal Siniestros No Estimados -->
        <div>
            <CModal :show.sync="modals.NoEstimados" ref="my-modal" :close-on-backdrop="false">
                <template #header-wrapper>
                    <div class="card-headerE text-center">
                        <h5 class="mt-4 mb-4" style="color:white"><i class="fal fa-times-circle fa-4x"></i></h5>
                    </div>
                </template>
                <template #footer-wrapper><span></span></template>
                <div class="card-body text-center">
                    <h1 style="color:dark">Error</h1>
                    <p class="text-center" style="color:dark">Existen siniestros no estimados:</p>
                    <div class="text-center"> 
                        <div class="row">
                            <div class="col 2"></div>
                            <div class="col-8"> 
                                <div class="card-body text-center">
                                    <ul v-for="(item, index) in listNOestimados" :key="index" class="list-group">
                                        <li class="list-group-item">{{item.Siniestro}}</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col 2"></div>
                        </div>
                    </div>
                    <div v-if="textArea" class="mb-3 mt-3">
                        <textarea v-model="comentarios" placeholder="Describe el motivo" class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                    </div>
                </div>
                <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
                    <CButton @click="modals.NoEstimados = false" color="secondary" class="mr-2">
                        OK
                    </CButton>
                </CCardFooter>
            </CModal>
        </div>

        // <!-- Modal proveedor -->
        <div>
            <CModal scrollable alignment="center" :show.sync="modals.proveedor">
                <template #header-wrapper>
                    <div class="card-header text-center">
                        <h5 style="color:white">Proveedores</h5>
                    </div>
                </template>
                <template #footer-wrapper><span></span></template>
                <div class="card-body text-center">
                    <div class="row">
                        <div class="col-10">
                            <input class="form-control" list="datalistOptions" id="exampleDataList" 
                            v-model="search" v-on:keyup.enter="searchProveedor" placeholder="Buscar...">
                        </div>
                        <div class="col-2">
                            <button @click="searchProveedor" type="button" class="btn btn-light container">
                                <i class="fal fa-search"></i>
                            </button>
                        </div>
                    </div>
                    <div>
                        <div class="list-group mt-3">
                            <table class="table">
                                <thead>
                                    <tr>
                                    <th scope="col">Proveedor</th>
                                    <th scope="col">RFC</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="proveedor" v-for="(prov, i) in datosPaginados" :key="i" :value="prov.CveProveedor" @click="valueProv(prov.CveProveedor, prov.Proveedor, prov.RFC)">
                                    <td><a>{{ prov.Proveedor }}</a></td>
                                    <td><a>{{ prov.RFC }}</a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div>
                        <nav aria-label="Page navigation example">
                            <ul class="pagination">
                                <li v-on:click="getpreviousPage" class="page-item">
                                    <a class="page-link" href="#" aria-label="Previous">
                                        <span aria-hidden="true">&laquo;</span>
                                    </a>
                                </li>
                                <li class="page-item" v-bind:class="isActive(pagina)" v-on:click="getDataPagina(pagina)" v-for="(pagina, i) in totalPaginas()" :key="i">
                                    <a class="page-link" href="#">
                                        {{pagina}}
                                    </a>
                                </li>
                                <li v-on:click="getNextPage" class="page-item">
                                    <a class="page-link" href="#" aria-label="Next">
                                        <span aria-hidden="true">&raquo;</span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
                    <CButton @click="modalProvCancel" color="secondary" class="mr-2">
                        Cancelar
                    </CButton>
                    <CButton @click="modals.proveedor = false" color="primary">
                        Aceptar
                    </CButton>
                </CCardFooter>
            </CModal>
        </div>
    <div class="text-center footer mt-5">
            <p class="mt-3">@Latino Seguros</p>
    </div>
    <loading
    :isLoading="isLoading"/>
    <ValidarDocumentosModal
    :listArchivos="listArchivosValida"
    :changeStatus="pruebaRadio"
    :mostrarPDF="mostrarPDF"
    :sendValidacion="guardarEstatus"
    />
    <IframeModal
    :documento="pdf"
    />
    <IframeInfoOperacionModal
    :documento="pdf"
    :isImage="isImage"
    />
    <EstatusImportacionModal
    :comentarios="comentarios"
    :email="email"
    :ifCancelada="ifCancelada"
    :status.sync="status"
    :tipoStatus="tipoStatus"
    @update:status="status = $event"
    @update:email="email = $event"
    @update:comentarios="comentarios = $event"
    :updateStatusImp="eliminar"
    />
    <AutorizacionIndividualModal
    :noEstimacion="noEstimacion"
    :tipoIG="tipoIG"
    :gastos="gastos"
    :porcentajeIVA="porcentajeIVA"
    :iva="iva"
    :isr="isr"
    :arrCoberturas="arrCoberturas"
    :autorizacionIndividual="autorizacionIndividualFun"
    @update:noEstimacion="noEstimacion = $event"
    @update:tipoIG="tipoIG = $event"
    @update:gastos="gastos = $event"
    @update:porcentajeIVA="porcentajeIVA = $event"
    @update:iva="iva = $event"
    @update:isr="isr = $event"
    />
    <ErrorModal
    :errorMessage="errorMessage"/>

    <SuccessModal
    :successrMessage="successMessage"/>

    <InfoOperacionModal
    :listDocs="resInfo2"
    :mostrarPDF="mostrarDocmuentoInfo"/>

    <ListProveedoresModal
    :datosPaginados="proveedoresList"
    :search="search"
    :searchProveedor="searchProveedor"
    @update:search="search = $event"
    @search-proveedor="searchProveedor"
    @select-proveedor="handleSelectProveedor"
    :idProv="idProv"
    :nomProv="nomProv"
    :RFCProv="RFCProv"
  />
    </div>
    
  </template>
  
<script>
import Loading from './Tools/loading.vue';
import NavbarSas from './navbarSas.vue';
import moment from 'moment';
import ValidarDocumentosModal from "./Modals/validarDocumentosModal.vue";
import IframeModal from "./Modals/iframeModal.vue";
import IframeInfoOperacionModal from "./Modals/iframeInfoOperacionModal.vue";
import EstatusImportacionModal from "./Modals/estatusImportacionModal.vue";
import AutorizacionIndividualModal from "./Modals/autorizacionIndividualModal.vue";
import InfoOperacionModal from "./Modals/infoOperacionModal.vue";
import ListProveedoresModal from "./Modals/listProveedoresModal.vue";
import ErrorModal from "./Modals/errorModal.vue";
import SuccessModal from "./Modals/successModal.vue";

// Importamos JQuery
const $ = require('jquery')
// Lo declaramos globalmente
window.$ = $


  export default {
  components: {
    NavbarSas, 
    Loading,
    ValidarDocumentosModal,
    IframeModal,
    EstatusImportacionModal,
    AutorizacionIndividualModal,
    ErrorModal,
    SuccessModal,
    InfoOperacionModal,
    ListProveedoresModal,
    IframeInfoOperacionModal
    },
  data() {
    return {
        errorMessage: '',
        successMessage: '',
        isLoading: false,

        itemsToShow: 10,
        paginaActual: 1,
        numImportacion: "",
        txtAjuste: "",
        FechaI: "",
        FechaF: "",
        b64XML: "",
        b64Comprobante: "",
        numFactura: "",
        proveedor: "",
        radio: "",
        pdf: "",
        importac: "",
        status: "",
        email: "",
        fechaCarga: "",
        ArchivoD: "",
        tipoArchivoD: "",
        nombreArchivoD: "",
        Importacion: "",
        archivoBase64Lista: "",
        solicitar: "",
        correcto: "",
        search: "",
        comentarios: "",
        idProv: 0,
        Autorizacion: "",
        noEstimacion: "",
        tipoIG: "",
        gastos: "",
        iva: "",
        isr: "",
        ajuste: 0,
        numIMPSelect: "",
        infoImportacion: "",
        porcentajeIVA: "",
        uuid: "",
        numOP: "",
        nomProv: "",
        RFCProv: "",
        imp: "",
        aut: "",
        base64data: "",
        textArea: false,
        check: true,
        autorizacion: true,
        bigDocument: false,
        isImage: false,
        fileXML: [],
        datosPaginados: [],
        listGetFile: [],
        proveedoresList: [],
        listStatus: [],
        listArchivosValida: [],
        resInfo: [],
        listSin: [],
        listResultados:[],
        resInfo2: [],
        listSiniestros: [],
        tipoStatus: [],
        listEstimados: [],
        listNOestimados: [],
        listArchivos: [],
        arrCoberturas: [],
        tipoDocumento: [],
        profileId: localStorage.getItem("profileId"),
        modals: { 
            validar: false,
            eliminar: false,
            info: false,
            proveedor: false,
            ver: false,
            NoEstimados: false,
            autorizacionIndividual: false
        },
        visibleVerticallyCenteredScrollableDemo: false,
        resInfo : {
            Factura: null,
            Importacion: null,
            FechaImportacion: null,
            TipoImportacion: null,
            Archivos: [],
            Siniestros: [],
      },
    }
  }, 
  methods: {
    openProveedor(){
        console.log('entra proveedor');
        
        this.$modal.show('proveedor-modal')
    },
    async openModal(Importacion){
        
        const promiseUno = new Promise((resolve, _) => {
            resolve(
                this.validarChecklist(Importacion, false)
            );
            });
            promiseUno.then(_ => {
                // this.modals.autorizacionIndividual = true; 
                this.$modal.show('autorizacion')
                this.noEstimacion = "" 
                this.tipoIG = "" 
                this.gastos = "" 
                this.porcentajeIVA = "" 
                this.iva = "" 
                this.isr = "" 
                this.numIMPSelect = Importacion
                let XML = ""
                this.listArchivosValida.map( (xml, i) => {
                    if(xml.IdArchivo == '140'){
                        XML = xml.NombreArchivo;
                    }
                })
                
                const promise = new Promise((resolve, _) => {
                    resolve(
                        this.CargaXML(XML) //Trae el Base64 del xml
                    );
                    });
                    promise.then(_ => {
                        this.getXML(this.b64XML)
                    }
                );
                this.coberturas()
                    }
                );

    },
    async cancelarImp(imp, aut){
        this.status = "";
        this.tipoStatus = [];
        this.tipoStatus = [
            { Descripcion: 'Esperando cambios', IdEstatusInd: '3' },
            { Descripcion: 'Aceptada', IdEstatusInd: '2' },
            { Descripcion: 'Pagada', IdEstatusInd: '7' },
            { Descripcion: 'Cancelada', IdEstatusInd: '5' }
        ]
        this.validarChecklist(imp, false)
        this.imp = imp;
        this.aut = aut;
        this.$modal.show('estatus-importacion')
        this.textArea = false
        this.comentarios = "";
        this.ordenesPago(aut)
        
    },
    async ordenesPago(autorizacion){
        this.isLoading = true;
        const payload = {
        metodo: "LISTARORDENESPAGOSSAS",
        data: {
            TipoCarga:"",
            FechaInicial:"",
            FechaFin:"",
            ClaveOrdenPago:"",
            NumAutorizacion: autorizacion
        },
        };  
        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST;
                this.numOP = res[0].OrdenesPago[0].NumOP
                setTimeout(() => {
                    this.comprobantePago()
                }, 1000)
            }
        } //Fin try
        catch (error) {
            this.isLoading = false;
            console.log(error);
        }
        this.isLoading = false;
        
    },
    async comprobantePago(){
        const payload = {
        metodo: "COMPROBANTEPAGOSAS",
        data: {
            NumOp: this.numOP
        },
        };  
        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST;
                this.b64Comprobante = res.data;
            }
        } //Fin try
        catch (error) {
            console.log(error);
        }
        
    },
    async sendEmail(){
        let monto = Number(this.infoImportacion.Siniestros[0].Monto)
        let arrArchivos = [];
        let stringArchivos = '';
        let dinamicContent = {};
        for (let i = 0; i < this.listArchivos.length; i++) {
            if(this.listArchivos[i].EstatusArchivo == '2'){
                if(this.listArchivos[i].IdArchivo != '140' && this.listArchivos[i].IdArchivo != '150'){
                    arrArchivos.push(this.listArchivos[i])
                }
            }
        };
        for (let e = 0; e < arrArchivos.length; e++) {
            stringArchivos += `**${arrArchivos[e].NombreArchivo}<br>`
            
        };
        switch (this.status) {
            case '5':
                //Cancelada pendiente
                dinamicContent = {
                    idTemplate: '84',
                    sender:"sistemas.danos@latinoseguros.com.mx",
                    subject: "Notificacion carga indivual proveedores",
                    targets: this.email,
                    dinamicContent:`${this.infoImportacion.Factura}|$${monto.toFixed(2)}|
                                    &quot;CANCELADA&quot.|${this.comentarios}|${this.infoImportacion.Siniestros[0].Siniestro}|
                                    ${this.infoImportacion.Siniestros[0].Poliza}|${this.infoImportacion.Siniestros[0].Inciso}|
                                    $${this.infoImportacion.Subtotal}`.toString(),     
                    idMessage:"77"
                };
                break;
            case '3':
                //Esperando cambios
                dinamicContent = {
                    idTemplate: '76',
                    sender:"sistemas.danos@latinoseguros.com.mx",
                    subject: "Notificacion carga indivual proveedores",
                    targets: this.email,
                    dinamicContent:`${this.infoImportacion.Factura}|$${monto.toFixed(2)}|
                                    ${this.comentarios}|${this.infoImportacion.Siniestros[0].Siniestro}|
                                    ${this.infoImportacion.Siniestros[0].Poliza}|${this.infoImportacion.Siniestros[0].Inciso}|
                                    $${this.infoImportacion.Subtotal}`.toString(),     
                    idMessage:"74"
                }; 
                break;
            case '2':
                //Aceptada
                dinamicContent = {
                    idTemplate: '77',
                    sender:"sistemas.danos@latinoseguros.com.mx",
                    subject: "Notificacion carga indivual proveedores",
                    targets: this.email,
                    dinamicContent:`${this.infoImportacion.Factura}|$${monto.toFixed(2)}|
                                    &quot;ACEPTADA&quot; y se encuentra en proceso de pago.|${this.infoImportacion.Siniestros[0].Siniestro}|
                                    ${this.infoImportacion.Siniestros[0].Poliza}|${this.infoImportacion.Siniestros[0].Inciso}|
                                    $${this.infoImportacion.Subtotal}`.toString(),     
                    idMessage:"77"
                };
                break;
            case '7':
                // Pagada
                dinamicContent = {
                    idTemplate: '77',
                    sender:"sistemas.danos@latinoseguros.com.mx",
                    subject: "Notificacion carga indivual proveedores",
                    targets: this.email,
                    dinamicContent:`${this.infoImportacion.Factura}|$${monto.toFixed(2)}|
                                    &quot;PAGADA&quot. |${this.infoImportacion.Siniestros[0].Siniestro}|
                                    ${this.infoImportacion.Siniestros[0].Poliza}|${this.infoImportacion.Siniestros[0].Inciso}|
                                    $${this.infoImportacion.Subtotal}`.toString(),     
                    idMessage:"77",
                    attachments:[
                        {
                            file:this.b64Comprobante,
                            name:"ComprobantePago.pdf"
                        }
                    ]
                };
                break;
        
            default:
                break;
        }
        const payload = {
        metodo: "SENDEMAILSAS",
        data: dinamicContent,
        };  
        if (this.status == '2' || this.status == '5' || this.status == '7' || this.status == '3') {
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST[0];
                }
            } //Fin try
            catch (error) {
                console.log(error);
            }
        }
    },
    pruebaRadio(i, selected){
        // console.log(i);
        // console.log(selected);
    },
    modalProvCancel(){
        this.modals.proveedor = false
        this.idProv = ""
    },
    getDataPagina(noPag){
        this.paginaActual = noPag;
        this.datosPaginados = [];
        let inicio = (noPag * this.itemsToShow) - this.itemsToShow
        let fin = (noPag * this.itemsToShow)
        this.datosPaginados = this.proveedoresList.slice(inicio, fin)
    },
    totalPaginas(){
        let paginas = Math.ceil(this.proveedoresList.length / this.itemsToShow)
        if(paginas > 11) {
            paginas = Math.ceil(this.proveedoresList.length / 60)
        }
        return paginas
    },
    getpreviousPage(){
        if(this.paginaActual > 1){
            this.paginaActual--;
        }
        this.getDataPagina(this.paginaActual)
    },
    getNextPage(){
        if(this.paginaActual < this.totalPaginas()){
            this.paginaActual++;
        }
        this.getDataPagina(this.paginaActual)
    },
    isActive(pagina){
        if(pagina == this.paginaActual){
            return 'active'
        } else {
            return
        }
    },
    handleSelectProveedor({ id, nombre, rfc }) {
      this.idProv = id;
      this.nomProv = nombre;
      this.RFCProv = rfc;
    },
    async searchProveedor(){
        this.isLoading = true;
        this.proveedoresList = []
        const payload = {
            metodo: "PPLISTARPROVEEDORES",
            data: {
                filtro: this.search.toUpperCase()
            },
        };
        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST[0];
                this.proveedoresList  = res.Prestadores 
                if(res.Prestadores[0].RFC == ""){
                    this.errorMessage = res.Prestadores[0].CveProveedor,
                    this.$modal.show('error-modal');
                }
            }
        } //Fin try
        catch (error) {
            console.log(error);
        }
        this.isLoading = false;
    },
    async validarChecklist(importacion, estado) {
        this.txtAjuste = ''
        for (let i = 0; i < this.listStatus.length; i++) {
            if(this.listStatus[i].Importacion == importacion){
                this.listStatus[i].DISABLED = false
            }
        }
        this.listArchivosValida = [];
        this.check = false
        if (estado) {
            this.$modal.show('validar-documento')
            // this.modals.validar = true;
        }
        this.isLoading = true;
        const payload = {
        metodo: "PPOBTENERARCHIVOSCARGADOSIND",
        data: {
            Importacion: importacion,
            NumFactura : this.numFactura,
            IdTipoServicio: "0"
        },
        };
        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST[0];
                this.listArchivosValida = res.Archivos;
                console.log(this.listArchivosValida);
                
                this.listArchivos = res.Archivos;
                this.infoImportacion = res
                this.archivosTipoServicio(res.IdTipoServicio, this.listArchivosValida)
                if (estado) {
                    this.CargarDocs()
                    console.log(res.Archivos.length);
                    if(res.Archivos.length == 0){
                        this.errorMessage = 'No hay documentos faltantes.',
                        this.$modal.show('error-modal');    
                        // this.openModalAlert('No hay documentos faltantes.', 'Error', 'fal fa-times-circle fa-5x', 'color:rgba(255, 0, 0, 0.651)', false)
                        setTimeout( () => {this.modals.validar = false;}, 1500)
                    }
                }
                // this.resArchivos = res;
            }
        } //Fin try
        catch (error) {
            console.log(error);
            this.isLoading = false;
        }
        this.isLoading = false;
    },
    async eliminar() {
        this.txtAjuste = ''
        let validaEmail = /\S+@\S+\.\S+/
        if (this.status == '2' || this.status == '5' || this.status == '7'){
            if(this.email == ''){
                this.errorMessage = 'El correo destinatario es obligatorio',
                this.$modal.show('error-modal'); 
                // this.openModalAlert('El correo destinatario es obligatorio', 'Error', 'fal fa-times-circle fa-5x', 'color:rgba(255, 0, 0, 0.651)', false)
                return;
            }
            if(!validaEmail.test(this.email)){
                this.errorMessage = 'El correo destinatario no es valido',
                this.$modal.show('error-modal'); 
                // this.openModalAlert('El correo destinatario no es valido', 'Error', 'fal fa-times-circle fa-5x', 'color:rgba(255, 0, 0, 0.651)', false)
                return;
            }
        }
        this.isLoading = true;
        const payload = {
            metodo: "PPACTUALIZARESTATUS",
            data: {
                IdEstatus: this.status,
                NumAutorizacion: this.aut,
                DesCancelacion: this.comentarios,
                Importacion: this.imp,
                IdCobertura: '',
                Monto: '',
                Siniestro: ''
            },
        };
        try {
            const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST[0];
                this.sendEmail()
                this.$modal.hide('estatus-importacion')
                this.successMessage = 'Importación actualizada correctamente'
                this.$modal.show('success-modal');
                // this.openModalAlert('Importación actualizada correctamente', 'Exito!', 'fal fa-check-circle fa-5x', 'color:#9BDC77', false)
                setTimeout( () => {this.email = ""; this.reporteCliente()}, 2000)
            } else{
                error = this.$store.getters.getDataRaw.errorMessage
                this.errorMessage = error,
                this.$modal.show('error-modal'); 
                this.isLoading = false;
                // this.openModalAlert(error, 'Error', 'fal fa-times-circle fa-5x', 'color:rgba(255, 0, 0, 0.651)', false)
            }
        } //Fin try
        catch (error) {
            console.log(error);
        }
        this.isLoading = false;
    },
    handleStatusChange(newStatus) {
        console.log(newStatus);
        
      this.status = newStatus;
    //   this.ifCancelada();
    },
    ifCancelada(){
        if(this.status == 5){
            this.textArea = true;
        } else {
            this.textArea = false;
        }
    },
    async CargaXML(archivo) {
        let nombreArchivo = archivo.split(".")
        this.isLoading = true;
        const payload = {
            metodo: "GETFILE",
            data: {
                psNombreArchivo: nombreArchivo[0],
                psExtension: "." + nombreArchivo[1],
                psIdOperacion: 5
            },
        };
        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST;
                this.b64XML = res
            }
        } //Fin try
        catch (error) {
            console.log(error);
            this.isLoading = false;
        }
        this.isLoading = false;
    },
    async CargarDocs() {
        for (let i = 0; i < this.listArchivosValida.length; i++) {
            let nombreArchivo = this.listArchivosValida[i].NombreArchivo.lastIndexOf('.');
            if (nombreArchivo !== -1) {
                var nombre = this.listArchivosValida[i].NombreArchivo.substring(0, nombreArchivo);
                var extension = this.listArchivosValida[i].NombreArchivo.substring(nombreArchivo + 1);
            }
            this.isLoading = true;
        const payload = {
            metodo: "GETFILE",
            data: {
                psNombreArchivo: nombre,
                psExtension: "." + extension,
                psIdOperacion: 5
            },
            };
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST;
                    this.listArchivosValida[i].archivoB64 = res
                    this.listGetFile.push(res)
                    
                }
            } //Fin try
            catch (error) {
                console.log(error);
                this.isLoading = false;
            }
            this.isLoading = false;
        }
    },
    async mostrarPDF(base64, nombre) {
        this.bigDocument = false
        const base64Length = base64.length;
        const fileSize = (base64Length * 3) / 4;
        console.log(fileSize);
        if(fileSize > 3000000){
            this.bigDocument = true
            this.base64data = base64
        }
        // this.fileSize = fileSize;
        // this.modals.ver = true
        this.$modal.show('ver-documento')
        let extencion = nombre.split(".")[1]
        switch (extencion) {
            case 'jpg':
                this.pdf = 'data:image/jpeg;base64,' + base64;
                break;
            case 'pdf':
                this.pdf = 'data:application/pdf;base64,' + base64;
                break;
            case 'png':
                this.pdf = 'data:image/png;base64,' + base64;
                break;
                case 'xml':
                this.pdf = 'data:text/plain;base64,' + base64;
                break;
            default:
                break;
        }
        // this.$modal.hide('info-operacion')
    },
    async mostrarDocmuentoInfo(base64, nombre) {
        this.bigDocument = false;
        const base64Length = base64.length;
        const fileSize = (base64Length * 3) / 4;

        if (fileSize > 3000000) {
            this.bigDocument = true;
            this.base64data = base64;
        }

        const extension = nombre.split(".").pop().toLowerCase();
        const mimeTypes = {
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'pdf': 'application/pdf',
            'png': 'image/png',
            'xml': 'text/plain',
        };

        const mimeType = mimeTypes[extension];
        if (mimeType) {
            this.pdf = `data:${mimeType};base64,${base64}`;
        } else {
            console.error('Unsupported file type:', extension);
            return;
        }
        if (['jpg', 'jpeg', 'png'].includes(extension)) {
            this.isImage = true;
        } else {
            this.isImage = false;
        }
        this.$modal.hide('info-operacion');
        this.$modal.show('ver-documento-info');
    },
    downloadDocument( ){
        const base64Data = this.base64data
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        
        // Crear un Blob a partir del contenido binario
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        
        // Crear un enlace para descargar el archivo
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'documento'; 
        link.click();
    },
    async reporteCliente() {
        this.txtAjuste = ''
        this.listStatus = [];
        let FechaIni = this.FechaI.split("-")
        let FechaFin = this.FechaF.split("-")
        
        this.isLoading = true;
        const payload = {
            metodo: "REPORTESTATUSCLIENTE",
            data: {
                RFC:"",
                Importacion: this.numImportacion,
                FechaInicial: this.FechaI == "" ? "" : FechaIni[2] + "/" + FechaIni[1] + "/" + FechaIni[0],
                FechaFinal: this.FechaF == "" ? "" :  FechaFin[2] + "/" + FechaFin[1] + "/" + FechaFin[0],
                NumFactura: this.numFactura,
                CveProveedor: this.idProv,
                TipoCarga: this.radio,
                IdConsulta: "",
                IdPerfil: localStorage.getItem('idRol'),
                IdAnalista: ''
            },
        };
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST;
                    console.log(res);
                    
                    this.Importacion = res[0].Importacion
                    
                    if(res[0].Importacion === "No se recibió ninguna condicion para la consulta")
                    {
                        this.errorMessage = res[0].Importacion,
                        this.$modal.show('error-modal'); 
                        // this.openModalAlert(res[0].Importacion, 'Error', 'fal fa-times-circle fa-5x', 'color:rgba(255, 0, 0, 0.651)', false)
                        this.isLoading = false;
                    }
                    else if(res[0].Importacion === "La consulta no generó datos")
                    {
                        this.errorMessage = res[0].Importacion,
                        this.$modal.show('error-modal'); 
                        this.isLoading = false;
                        // this.openModalAlert(res[0].Importacion, 'Error', 'fal fa-times-circle fa-5x', 'color:rgba(255, 0, 0, 0.651)', false)
                    }  else {
                        this.importac = res.Importacion
                        this.listStatus.push(...res)
                        let temp = this.listStatus[0]
                        for (let i = 0; i < temp.length; i++) {
                            if(res.Tipo == temp.Tipo){
                                temp[i].DISABLED = true
                            }
                        }
                        this.isLoading = false;

                    }
                } else {
                    this.errorMessage = "Error al validar los datos.",
                    this.$modal.show('error-modal'); 
                    // this.openModalAlert("Error al validar los datos.", 'Error', 'fal fa-times-circle fa-5x', 'color:rgba(255, 0, 0, 0.651)', false)
                }
            } 
            catch (error) {
                console.log(error);
            }
            this.isLoading = false;
    },
    async autorizar(importacion){ 
        this.txtAjuste = ''
        this.listNOestimados= [];
        this.listArchivosValida = [];
        this.listEstimados = [];
        const listArchivos = [];

        let today = new Date();

        let day = today.getDate();
        var month = today.getMonth() + 1;
        var year = today.getFullYear();
        var fechaActual = day + "/" + month + "/" + year
        this.isLoading = true;
        const payloadArchivos = {
            metodo: "PPOBTENERARCHIVOSCARGADOSIND",
            data: {
                Importacion: importacion,
                NumFactura : this.numFactura,
                IdTipoServicio: "0"
            },
        };
        try {
            const responseArchivos = await this.$store.dispatch("metodoPost", payloadArchivos);
            if (responseArchivos) {
                const res = this.$store.getters.getRespuestaREST[0];
                this.resInfo = res
                this.listArchivosValida = res.Archivos
                this.listSiniestros = res.Siniestros
                this.uuid = res.Uuid
                this.listArchivosValida.map(el => el.selectedFile = false);

                //Validar siniestros
                const payloadSiniestros = {
                    metodo: "VALIDASINIESTROSEXISTENTES",
                    data: {
                        SiniestrosExistentes: this.listSiniestros
                    },
                }; 
                try {
                    const responseSiniestros = await this.$store.dispatch("metodoPost", payloadSiniestros);
                    if (responseSiniestros) {
                        const resSiniestros = this.$store.getters.getRespuestaREST[0].SiniestrosExistentes;
                        resSiniestros.map(element => {
                            var obj = {
                                SubTotalSiniestro: this.resInfo.Subtotal, // PPObtenerArchivosCargadosInd
                                IDImpuesto: "1",
                                NumSiniestro : element.Siniestro,
                                IdCobertura: element.IdCobertura,
                                Poliza: element.Poliza //ValidaSiniestrosExistentes
                            }
                            listArchivos.push(obj)
                        });
    
                        for (let i = 0; i < resSiniestros.length; i++) {
                            if(resSiniestros[i].Estimado == "1"){
                                this.listEstimados.push(resSiniestros[i])
                            }
                            if(resSiniestros[i].Estimado == "0"){
                                this.listNOestimados.push(resSiniestros[i])
                            }
                        } 
                        
                        if(listArchivos.length != this.listEstimados.length){
                            this.modals.NoEstimados = true;

                        } else {
                            const listS = [];
                            for (let index = 0; index < resSiniestros.length; index++) {
                                if(resSiniestros[index].Siniestro == this.listSiniestros[index].Siniestro){
                                    var obj = {
                                        SubTotalSiniestro: this.listSiniestros[index].Monto, // PPObtenerArchivosCargadosInd
                                        IDImpuesto: "1",
                                        NumSiniestro : resSiniestros[index].Siniestro,
                                        IdCobertura: resSiniestros[index].IdCobertura,
                                        Poliza: resSiniestros[index].Poliza //ValidaSiniestrosExistentes
                                    }
                                    listS.push(obj)
                                }
                            }
                            const payloadFactura = {
                                metodo: "PAGOFACTURA",
                                data: {
                                    facturaSiniestro: {
                                        IdTipoGasto: "36",
                                        ClaveProveedor: this.resInfo.CveProveedor, //PPObtenerArchivosCargadosInd
                                        RFC: this.resInfo.RFC, //PPObtenerArchivosCargadosInd
                                        NumFactura: this.uuid, //PPObtenerArchivosCargadosInd
                                        FechaEmisionCarga: fechaActual,
                                        FechaPago: fechaActual,
                                        RazonSocial: this.resInfo.NombreProveedor,
                                        SubTotalFactura: this.resInfo.Subtotal // PPObtenerArchivosCargadosInd
                                    },
                                    lPagoSiniestro: listS
                                    
                                },
                            };
                            try {
        
                                const responseFactura = await this.$store.dispatch("metodoPost", payloadFactura);
                                const resAut = this.$store.getters.getRespuestaREST;
                                if (responseFactura) {
                                    if(resAut != null) {
                                        this.successMessage = "Número de autorización generado: "  + resAut.NumAutorizacion
                                        this.$modal.show('success-modal');
                                        // this.openModalAlert("Número de autorización generado: "  + resAut.NumAutorizacion, 'Autorizacion exitosa!', 'fal fa-check-circle fa-5x', 'color:#9BDC77', false)
                                        this.cambiaStatusAutorizada(importacion, this.comentarios, resAut.NumAutorizacion);
                                        this.reporteCliente()
                                    }
                                    else {
                                        this.errorMessage = 'Autorizacion no exitosa',
                                        this.$modal.show('error-modal'); 
                                        // this.openModalAlert('Autorizacion no exitosa', 'Error', 'fal fa-times-circle fa-5x', 'color:rgba(255, 0, 0, 0.651)', false)
                                    }
                                } 
                            } 
                            catch (errorE) {
                                console.log(errorE);
                                this.isLoading = false;
                            }
                        }
    
                        //Pago Factura
                    }
                } 
                catch (errorE) {
                    this.isLoading = false;
                }
            }
            } //Fin try
        catch (error) {
            console.log(error);
            this.isLoading = false;
        }
    },
    async cambiaStatusAutorizada(imp, coment, aut, monto, cobertura, siniestro){
        let claveCob = "";
        this.txtAjuste = ''
        this.arrCoberturas.map( data => {
            if(data.NumEstimacion == cobertura){
                claveCob = data.ClaveCobertura
            }
        });
        this.isLoading = true;
        const payload = {
        metodo: "PPACTUALIZARESTATUS",
        data: {
            IdEstatus: "6",
            NumAutorizacion: aut,
            DesCancelacion: coment,
            Importacion: imp,
            IdCobertura: claveCob,
            Monto: monto,
            Siniestro: siniestro
        },
        };

        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST;
                this.ajuste = Number(res.Ajuste);
                console.log('Ajuste desde metodo Actualiza Status ' + this.ajuste);
            }
        }
        catch (error) {
            console.log(error);
            this.isLoading = false;
        }
        this.isLoading = false;
    },
    async getXML(b64){
        this.fileXML= []
        this.isLoading = true;
        const payload = {
        metodo: "VALIDARDOCUMENTOSXML",
        data: {
            DocumentXmlBase64: b64
        },
        };
        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST;
                this.fileXML.push(res)
            }}
        catch(e){
            console.log(e);
            this.isLoading = false;
        }
        this.isLoading = false;
    },
    async autorizacionIndividualFun(){
        this.txtAjuste = ''
        let xml = ''
        if(this.noEstimacion == "" && this.tipoIG == "") {
            this.errorMessage = 'Todos los campos son obligatorios',
            this.$modal.show('error-modal'); 
            // this.openModalAlert("Todos los campos son obligatorios.", 'Error', 'fal fa-times-circle fa-5x', 'color:rgba(255, 0, 0, 0.651)', false)
            return;
        }
        xml = this.fileXML[0].TransactionProperties
        
        let fecha = ""
        let fechaFactura = ""
        let subtotal = ""
        let ifReserva = ''
        let IVA = ""
        let descuento = 0
        let uuid = 0

        xml.map( datos => {
            if(datos.keyField == 'Fecha Emision'){
                fecha = datos.valueField;
                fecha = moment(fecha).format('DD/MM/YYYY');
            }
            if(datos.keyField == 'Subtotal'){ subtotal = datos.valueField; }
            if(datos.keyField == 'Total Impuestos Trasladados'){ IVA = datos.valueField; }
            if(datos.keyField == 'Descuento'){ descuento = datos.valueField; }
            if(datos.keyField == 'UUID'){ uuid = datos.valueField; }
        })

        let cobertura = ''
        xml.map( (obj) => {
            if(obj.keyField == 'Subtotal'){
                this.arrCoberturas.map(cob => {
                    if(cob.NumEstimacion == this.noEstimacion){
                        cobertura = cob.Saldo.replace(/,/g, '');;
                    }
                })
            }
            if(obj.keyField == 'Fecha Emision'){
                fechaFactura = obj.valueField
            }
        })
        this.isLoading = true;
        const payload = {
        metodo: "AUTORIZACIONINDIVIDUALSAS",
        data: {
            Siniestro: this.infoImportacion.Siniestros[0].Siniestro,
            DocumentXmlBase64: this.b64XML,
            Autorizaciones : [ 
            {
                TipoBeneficiario: "P",
                CodigoBeneficiario: this.infoImportacion.CveProveedor,
                MontoSinIVA: (subtotal - descuento).toFixed(2),
                FechaPago: "",
                IngresoGasto: this.tipoIG,
                NroEstimacion: this.noEstimacion,
                CodigoGasto: this.gastos == "" ? "1" : this.gastos,
                UUIDFactura: uuid,
                CodigoIva: this.porcentajeIVA,
                RetencionISR: this.isr != '' ? 'S' : 'N',
                RetencionIVA: this.iva  != '' ? 'S' : 'N',
                FormaPagoNC: "99",
                FechaElaboracionFactura: fechaFactura
            }
            
            ]
        },
        };

        try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
            const res = this.$store.getters.getRespuestaREST[0];
            if(res.Autorizaciones[0].NumeroAutorizacion){
                this.$modal.hide('autorizacion')
                const promise = new Promise((resolve, _) => {
                    resolve(
                        this.cambiaStatusAutorizada(this.numIMPSelect, '', res.Autorizaciones[0].NumeroAutorizacion, subtotal - descuento, this.noEstimacion, this.infoImportacion.Siniestros[0].Siniestro,)
                    );
                    });
                    promise.then(_ => {
                        this.reporteCliente();
                        console.log(this.tipoIG);
                        this.successMessage = "Número de autorización generado: "  +res.Autorizaciones[0].NumeroAutorizacion
                        this.$modal.show('success-modal');
                    if(this.tipoIG != 'G'){
                        if(Number(this.ajuste) > 0){
                        this.successMessage =`Número de autorización generado: ${res.Autorizaciones[0].NumeroAutorizacion}. \nLa reserva no es suficiente, ajustar $${ this.ajuste }`
                        // this.txtAjuste = `La reserva no es suficiente, ajustar $${ this.ajuste }`
                        }
                    }
                    // this.openModalAlert("Número de autorización generado: "  + res.Autorizaciones[0].NumeroAutorizacion, 'Autorizacion exitosa', 'fal fa-check-circle fa-5x', 'color:#9BDC77', false)
                    }
                );
            }
            } else {
                let error = ""
                error = this.$store.getters.getDataRaw.errorMessage
                this.errorMessage = error,
                this.$modal.show('error-modal'); 
                this.isLoading = false;
                // this.openModalAlert(error, 'Error', 'fal fa-times-circle fa-5x', 'color:rgba(255, 0, 0, 0.651)', false)
            }
        } //Fin try
        catch (error) {
            console.log(error);
            this.isLoading = false;

        }
    },
    async guardarEstatus(){
    const listArchivos = [];
    this.txtAjuste = ''
        this.listArchivosValida.map(element => {
            var obj = {
                IdArchivo: element.IdArchivo,
                Estatus: element.selectedFile ? "1" : "2",
                Cantidad: "1"
            }
            listArchivos.push(obj)
        });
        this.isLoading = true;
        const payload = {
            metodo: "PPGUARDARESTATUSEVALUACIONARCHIVOS",
            data: {
                NumImportacion: this.infoImportacion.Importacion,
                NumFatura: this.resInfo.Factura,
                FechaEvaluacion: this.fechaCarga,
                EstatusAceptacion: this.status,
                Comentarios:"NA",
                Archivos: listArchivos
            },
        };   
            try {
                const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST[0];
                    if(res.Importacion != ""){
                        this.successMessage = res.Mensaje
                        this.$modal.show('success-modal');
                        // this.openModalAlert(res.Mensaje, 'Exito!', 'fal fa-check-circle fa-5x', 'color:#9BDC77', false)
                        this.$modal.hide('validar-documento')                
                    }
                    
                }
            } //Fin try
            catch (error) {
                console.log(error);
                this.isLoading = false;
            }
            this.isLoading = false;
    },
    async cargarDocsIndividual() {
        this.resInfo2.map(async doc => {
            let nombreArchivo = doc.NombreArchivo.split(".")
            this.isLoading = false;
            const payload = {
                metodo: "GETFILE",
                data: {
                    psNombreArchivo: nombreArchivo[0],
                    psExtension: "." + nombreArchivo[1],
                    psIdOperacion: 5
                },
            };
            try {
                const response = await this.$store.dispatch("metodoPost", payload);
                    if (response) {
                        const res = this.$store.getters.getRespuestaREST;
                        doc.archivoB64 = res
                        this.listGetFile.push(res)
                    }
                } //Fin try
            catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        
        })
    },
    async info(imp){
        this.$modal.show('info-operacion'); 
        this.isLoading = true;
        const payload = {
            metodo: "PPOBTENERARCHIVOSCARGADOSIND",
            data: {
                Importacion: imp,
                NumFactura : this.numFactura,
                IdTipoServicio: "0"
            },
            };
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST[0];
                    this.resInfo2 = res.Archivos
                    if(res.Archivos.length == 0){
                        this.errorMessage = 'No hay documentos faltantes.',
                        this.$modal.show('error-modal'); 
                        this.isLoading = false;
                        this.$modal.hide('info-operacion'); 
                        return;
                    }
                    this.archivosTipoServicio(res.IdTipoServicio, this.resInfo2)
                    this.cargarDocsIndividual()
                }
            } //Fin try
            catch (error) {
                console.log(error);
            }
            this.isLoading = false;
    },
    async coberturas(){
        this.arrCoberturas = []
        this.isLoading = true;
        const payload = {
            metodo: "CONSULTACOBERTURASSAS",
            data: {
                NumeroSiniestro: this.infoImportacion.Siniestros[0].Siniestro
            },
            };
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST;
                    res.map( cobertura => {
                        if(cobertura.DescCobertura != ''){
                            let coberturas = {
                            DescCobertura: cobertura.DescCobertura,
                            NumEstimacion: cobertura.NumEstimacion,
                            Saldo: cobertura.Saldo,
                            ClaveCobertura: cobertura.ClaveCobertura
                            }
                            this.arrCoberturas.push(coberturas)
                        }
                    })
                }
            } //Fin try
            catch (error) {
                console.log(error);
                this.isLoading = false;
            }
            this.isLoading = false;
    },
    convertBase64(blob) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
            resolve(reader.result.split(",")[1]);
            };
        });
    },
    eventChecks(e, check) {
        if(e.target.checked) {
            switch (check) {
                case 'uno':
                this.radio = "Individual"
                break;
                case 'dos':
                    this.radio = "Masivo"
                    break;
                default:
                    break;
            }
            
        }
    },
    async archivosTipoServicio(id, list) {
        this.isLoading = true;
        const payload = {
        metodo: "PPLISTAARCHIVOSTIPOSERVICIO",
        data: {
            IdTipoServicio: id
        },
        };
        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST;
                this.tipoDocumento = res[0].Documentos
                let facturaXML = {
                    Descripcion: 'Factura XML',
                    IdArchivo: '140'
                }
                this.tipoDocumento.push(facturaXML)
                let facturaPDF = {
                    Descripcion: 'Factura PDF',
                    IdArchivo: '150'
                }
                this.tipoDocumento.push(facturaPDF)
                setTimeout(() => {
                    list.map( (data, i) => {
                        this.tipoDocumento.map( datos => {
                            if(data.IdArchivo == datos.IdArchivo){
                                this.$set(data,'tipoArchivo', datos.Descripcion)
                            }
                        })
                    })
                },1000)
            }
            this.isLoading = false;
        } //Fin try
        catch (error) {
            console.log(error);
            this.isLoading = false;
        }
    },
  },
  mounted() {
    // this.$modal.show('estatus-importacion')
    },
  }
  </script>
  
  <style scoped>
    .modal-content {
        background-color: white !important;
    }
    .btn-primary-operacion{
        background-color: #2b6fd4;
        border: #2b6fd4;
        color: white;
        padding: 7px;
    }
    .btn-info{
        background-color: #003c71;
        border: #003c71; 
        margin-top: 3px;
    }
    .btn-blue{
        border-radius: 10px;
        background-image: linear-gradient(to right, #085da8, #003c71); /* Color de fondo verde */
        border: #003c71;
        color: #ffffff;
    }
    .btn-modal{
        background-color: #3085d6;
        color: #ffffff;
        font-size: medium;
    }
    .card-header-error {
        background-color: rgb(255, 255, 255);
        height: 8rem;
    }
    .border-radius-btn{
        border-radius: 10px;
    }

    textarea {
    width: 260px;
    }
    .selectedItem{
    cursor: pointer;
    background-color: #d4ddf7;
    }
    .proveedor:hover{
    cursor: pointer;
    background-color: #d4ddf7;
    }
    .proveedor:focus{
    box-shadow: 0 0 0 2px white, 0 0 0 4px 
    }
    .proveedor:active {
    box-shadow: 0 0 0 2px white, 0 0 0 4px 
    }
    .iframePdf {
    width: 770px;
    height: 400px;
    }
    .cardxs{
    margin: 0;
    /* height: 70px; */
    }
    .columnaIconoxs{
        background-color: #d4ddf7;
    }
    .card-header {
        background-color: rgb(33, 46, 102);
    }
    .card-headerE {
        background-color: rgb(219, 102, 102);
    }
    small{
        font-size: small;
    }
    .titulo {
        color: #000000;
    }
    .file-select {
        position: relative;
        display: inline-block;
        width: 100px;
        height: 20px;
        margin-right: 30px;
        cursor: pointer;
    }

    .file-select::before {
        background-color: #ffffff;
        color: rgb(0, 0, 0);
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 3px;
        font-size: 12px;
        content: "Cargar archivo";
        /* text-decoration: underline rgb(0, 0, 0); */
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }
/* html {
min-height: 100%;
position: relative;
} */
/* body {
margin: 0;
margin-bottom: 40px;
} */

.footer{
position:fixed;
left:0px;
bottom:0px;
height:60px;
width:100%;
background:rgb(196, 196, 196);
}
#yourBtn {
font-family: calibri;
width: 170px;
/* text-align: center; */
margin-left:  20px;
background-color: rgb(255, 255, 255);
cursor: pointer;
}
.navbar{
    background-color: white;
    height: 90px;
}
.imagen {
    height: 50px;
}
.cardxl{
    height: 30rem;
    width: 23rem;
}
.icono {
    color: #000000;
}
.columnaIcono{
    background-color: #ECE9E8;

}
.fila{
    margin-left: 1px;
}
.coltxt{
    padding: 10px;
    line-height: 0; 
}
.tarjetaOperacion{
border-radius: 30px;
box-shadow: 10px 10px 25px 4px rgba(0,0,0,0.1);
}
</style>